// removed by extract-text-webpack-plugin
module.exports = {"answerAnalysis":"src-components-Practice-Material-answerAnalysis-answerAnalysis-3r-q9","analysisTitle":"src-components-Practice-Material-answerAnalysis-analysisTitle-LH2lE","analysisText":"src-components-Practice-Material-answerAnalysis-analysisText-eK230","writingButton":"src-components-Practice-Material-answerAnalysis-writingButton-3qKpE","writingTitle":"src-components-Practice-Material-answerAnalysis-writingTitle-1igI1","writingText":"src-components-Practice-Material-answerAnalysis-writingText-1hOf6","wordCount":"src-components-Practice-Material-answerAnalysis-wordCount-2Jmb9","myAnswer":"src-components-Practice-Material-answerAnalysis-myAnswer-q9VLJ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Practice/Material/answerAnalysis.css
 ** module id = 272
 ** module chunks = 0
 **/